export default __webpack_public_path__ + "static/banner-four-shape10-d37d886c533a4d2f4b4540ee723cea37.png";